<template>
<div>
  <div class="leftformitem">
    <div class="leftformtitle">
      {{property.name}}
      <span v-if="property.checked" class="ischeck">*</span>
    </div>
    <div class="leftformbd">
      <div class="leftforminput">请选择地区</div>
    </div>
    <i class="el-icon-arrow-down"></i>
  </div>
  <div class="leftformitem" v-if="property.radio==1">
    <div class="leftformtitle">详细地址</div>
    <div class="leftformbd">
      <div class="leftforminput">请输入地址</div>
    </div>
  </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
    };
  }
};
</script>


 